import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { PricingDto } from '@dto/pricingDto';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PricingsService } from '@services/entity/pricings.service';
import { ToastService } from '@services/toast/toast.service';
import { plainToClass } from 'class-transformer';
import { NgSelectComponent } from '@ng-select/ng-select';
import { ChargingStationByGroupDto } from '@dto/chargingStationByGroupDto';
import { UserDto } from '@dto/userDto';
import { UsersService } from '@services/entity/users.service';
import { FormService } from '@services/form/form.service';
import { BillingMethodEnum } from '@enums/billingMethodEnum.enum';
import { InvoiceItemDto } from '@dto/invoiceItemDto';
import { TableColumn } from '@models/tableColumn';
import { KwhPipe } from 'src/app/pipes/kwh.pipe';
import { CurrencyPipe } from '@angular/common';
import { RemovePricingRequest } from '@dto/removePricingRequest';
import { OpenItemsActionEnum } from '@enums/openItemsActionEnum.enum';

@Component({
  selector: 'app-remove-pricing-dialog-content',
  templateUrl: './remove-pricing-dialog-content.component.html',
  styleUrls: ['./remove-pricing-dialog-content.component.scss']
})
export class RemovePricingDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'RemovePricingDialogContentComponent';
  public recipientNamesDisplay: string;
  public openItemsAction: OpenItemsActionEnum = OpenItemsActionEnum.LaterBilling;
  public shouldKeepAuth: boolean = false;

  @Input() public step: number = 1;
  @Input() public invoiceItems: InvoiceItemDto[] = []
  @Input() public removedUsers: UserDto[] = []
  @Input() public billingMethod: BillingMethodEnum


  constructor(
    public activeModal: NgbActiveModal,
    public dialog: NgbModal,
    private pricingsService: PricingsService,
    private spinnerService: NgxSpinnerService,
    private usersService: UsersService,
    private formService: FormService,
    private toastService: ToastService,
    injector: Injector) {
    super(activeModal, injector);
  }


  async ngOnInit() {
    super.ngOnInit();
    const uniqueRecipientNames = [
      ...new Map(
        this.removedUsers.map(u => [
          u.email,
          { fullName: u.fullName, email: u.email }
        ])
      ).values()
    ];
    this.recipientNamesDisplay = uniqueRecipientNames
      .map(u => `${u.fullName} (${u.email})`)
      .join(', ');  
  }

  instantBilling() {
    this.openItemsAction = OpenItemsActionEnum.InstantBilling;
    this.step++;
  }

  noMoreBilling() {
    this.openItemsAction = OpenItemsActionEnum.NoMoreBilling;
    this.step++;
  }

  laterBilling()
  {
    this.step++;
  }

  keepAuth()
  {
    this.shouldKeepAuth = true
    this.submit()
  }
  removeAuth()
  {
    this.submit()
  }

  submit()
  {
    
    const request = new RemovePricingRequest();
    request.openItemsAction = this.openItemsAction;
    request.shouldKeepAuth = this.shouldKeepAuth;
    request.invoiceItemIds = this.invoiceItems.map(ii => ii.id);
    request.userIds = this.removedUsers.map(u => u.id);
    request.BillingMethod = this.billingMethod;
    this.pricingsService.removePricingFromUsers(request).subscribe(result => {
      this.spinnerService.hide()
      this.pricingsService.emitPrepared(true)
    }, error => {
      this.spinnerService.hide()
      console.error(error)
      this.toastService.error(`Tarif könnte nicht von dem Benutzer entfernt werden!`, 0, true)
    })
    this.activeModal.close();

  }

  parseDate(date: Date) {
    if (!date) return false
    return new Date(date).toLocaleDateString()
  }

  close() {
    this.activeModal.close();
  }
}
